import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { RestService } from 'src/app/services/rest.service';
import { AuthService } from 'src/app/services/auth.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ChangePasswordComponent } from '../../modal/change-password/change-password.component';
import { GeneralService } from 'src/app/services/general.service';
import { select, Store } from '@ngrx/store';
import * as Reducers from 'src/app/store/reducers';
import * as DrawerActions from 'src/app/store/drawers/actions';
import { NotificationComponent } from '../../widgets/drawer/components/notification/notification.component';
import { environment } from 'src/environments/environment';
import { AmToasterService } from '@angularminds/am-toaster';
import { AmDrawerService, AmDrawer } from '@angularminds/am-drawer';

@Component({
  selector: 'am-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent {
  bsModalRef: BsModalRef;
  user: any = {};

  // notification variables
  isNotificationsDrawerOpen: boolean = false;
  pageNo = 1;
  limit = 20;
  messages: any[] = [];
  totalCount: number;
  unreadCount: number;
  notificationCount: number;
  invites: any;

  constructor(
    private store: Store<any>,
    private bsModalService: BsModalService,
    private router: Router,
    private amToasterService: AmToasterService,
    private authService: AuthService,
    private generalService: GeneralService,
    private restService: RestService,
    private amDrawerService: AmDrawerService,
    private amDrawer: AmDrawer,
  ) {}

  ngOnInit() {
    this.getUserProfile();
    this.getNotifications();
    this.generalService.sharedNotification.subscribe((res: any) => {
      this.notificationCount = res.unreadCount;
    });

    this.getInvites();
  }

  getUserProfile() {
    this.authService.currentUser.subscribe(user => {
      this.user = user;
    });
  }

  getInitials(str) {
    return str ? str.charAt(0) : '';
  }

  showChangePasswordModal() {
    this.bsModalRef = this.bsModalService.show(ChangePasswordComponent, {
      ignoreBackdropClick: true,
      class: 'modal-md',
    });
  }

  goPlaces(url) {
    this.router.navigate(['/', url]);
  }

  logout() {
    this.authService.logout().subscribe(
      response => {
        // window.location.href = `${environment.baseUrl}/auth/login`;
        this.router.navigate(['/auth/login']);
      },
      error => {
        this.amToasterService.show('error', error, 'Error!');
      },
    );
  }

  /**
   * get notifications for user
   */
  getNotifications() {
    this.generalService.getNotifications(this.pageNo, this.limit).subscribe((res: any) => {
      this.messages = [...res.messages];
      this.unreadCount = res.unreadCount;
      this.totalCount = res.totalCount;
      this.generalService.setNotifications(res);
    });
  }

  showNotificationsDrawer() {
    this.amDrawerService.show(NotificationComponent, {
      placement: 'right',
      type: 'sidebar',
    });
  }

  closeNotificationDrawer() {
    this.amDrawer.close();
  }

  getInvites() {
    this.generalService.loadInvites();
    this.generalService.sharedInvites.subscribe(
      invites => {
        this.invites = invites;
      },
      error => {
        this.amToasterService.show('error', error, 'Error!');
      },
    );
  }
}
